import { ColorsV2, getToken, Pane, spaces, sizes } from '@electricjs/arc';

import styled from 'styled-components';

export const ConfigurationDetailPane = styled(Pane)`
  border-radius: ${sizes.size_8};
  border: 1px solid ${getToken(ColorsV2.GRAY_LIGHT)};
  padding: ${spaces.space_m};
  background-color: ${getToken(ColorsV2.WHITE)};
`;
